import React from "react";
import { Snackbar } from "@origin-digital/ods-core";
import FormContext from "src/context/FormContext";

export const SnackbarSection = () => {
  const { displayingSnackbar, setDisplayingSnackbar } =
    React.useContext(FormContext);
  return displayingSnackbar ? (
    <Snackbar
      data-id="snackbar"
      open
      showClose
      tone={displayingSnackbar.tone}
      autoHideDuration={5000}
      onClose={() => setDisplayingSnackbar(null)}
      align="left"
    >
      {displayingSnackbar.message}
    </Snackbar>
  ) : null;
};
